import { Component, h } from 'preact';
import * as appStyles from '../../../../assets/global.scss';
import { AmHolidayTypes, AmLocation, AmLocations, Location, LocationType } from '../../../../common';
import { ModalProps } from '../../../../modal';
import { actions, Actions, BookingState, connectStore } from '../../../../store';
import { withStyles, WithStyles } from '../../../../style';
import { isBlank } from '../../../../utils';
import { amLocationToListItem, locationLevenshteinPartialMatchSort, locationToItem } from '../../locationUtils';
import * as styles from '../LocationModal.scss';
import LocationModalBase from '../LocationModalBase';
import { LocationItem } from '../LocationResult/LocationResult';
import { GtmService, WidgetTestVariant } from '../../../../config';

export interface AmLocationModalProps extends ModalProps {
  locationType: LocationType;
  testVariant: WidgetTestVariant;
}

interface StoreProps {
  locale: string;
  destinations: AmLocation[];
  origins: Location[];
  holidayTypes: AmHolidayTypes;
  gtmService: GtmService;
  amLocations: AmLocations;
}

type EffectiveProps = AmLocationModalProps & StoreProps & Actions & WithStyles;
type State = {
  query: string;
};

const mapStateToProps = ({
  selection: { locale },
  amState: {
    destinations,
    origins,
    holidayTypes,
    amSelection: { locations: amLocations },
  },
  extensionApi: { gtmService },
}: BookingState): StoreProps => ({
  locale,
  destinations,
  origins,
  holidayTypes,
  gtmService,
  amLocations,
});

@withStyles(styles, appStyles)
@connectStore({ mapStateToProps, actions })
export default class AmLocationModal extends Component<AmLocationModalProps, State> {
  state = {
    query: '',
  };

  get locations(): LocationItem[] {
    const { locationType, origins, destinations } = this.props as EffectiveProps;
    const { query } = this.state;
    if (locationType === LocationType.ORIGIN) {
      if (isBlank(query)) {
        return [...origins].filter(Boolean).map(locationToItem);
      }
      return [...origins].sort(locationSorting(query)).filter(Boolean).map(locationToItem);
    }

    if (isBlank(query)) {
      return [...destinations].map(amLocationToListItem);
    }
    return [...destinations].sort(locationLevenshteinPartialMatchSort(query)).map(amLocationToListItem);
  }

  selectLocation = (location: LocationItem): void => {
    const { locationType, origins, setAmOrigin, destinations, setAmDestination } = this.props as EffectiveProps;
    if (locationType === LocationType.ORIGIN) {
      const selectedLocation = origins.find((loc) => loc.locationCode === location?.locationCode);
      setAmOrigin(selectedLocation);
    } else {
      const amLocation = destinations.find((loc) => loc.city === location.title);
      setAmDestination(amLocation);
    }
    this.context.modal.hideModal();
  };

  setLocationQuery = (query: string): void => this.setState(() => ({ query }));

  render(modalProps: EffectiveProps): h.JSX.Element {
    return (
      <LocationModalBase
        locations={this.locations}
        onLocationSearch={this.setLocationQuery}
        onLocationSelect={this.selectLocation}
        locationType={LocationType.DESTINATION}
        listId={`am-${this.props.locationType}`}
        {...modalProps}
      />
    );
  }
}

const locationSorting = (query: string) => (a: Location, b: Location) =>
  locationLevenshteinPartialMatchSort(query)(
    { city: a.title, country: a.country },
    { city: b.title, country: b.country }
  );
